<template>
	<div>
		<div class="flex-between">
			<div class="header">
				<h2>{{ $t('order_progress.order') }}</h2>
			</div>
		</div>
		<div class="order-description">
			<div class="flex-between">
				<div>{{ $t('order_progress.errand_pickup_address') }}:</div>
				<div>{{ order.o2o_errand_order_pickup_address }}</div>
			</div>
			<div class="flex-between">
				<div></div>
				<div class="address-detail">
					<span class="left">{{ $t('order_progress.errand_pickup_member') }}</span>
					<span class="center">{{ order.o2o_errand_order_pickup_name }}</span>
					<span class="right">{{ order.o2o_errand_order_pickup_phone }}</span>
				</div>
			</div>
			<div class="flex-between">
				<div>{{ $t('order_progress.errand_deliver_address') }}:</div>
				<div>{{ order.o2o_errand_order_deliver_address }}</div>
			</div>
			<div class="flex-between">
				<div></div>
				<div class="address-detail">
					<span class="left">{{ $t('order_progress.errand_deliver_name') }}</span>
					<span class="center">{{ order.o2o_errand_order_deliver_name }}</span>
					<span class="right">{{ order.o2o_errand_order_deliver_phone }}</span>
				</div>
			</div>
		</div>
		<div class="flex-between">
			<div class="titleBox"><h2>{{ $t('order_progress.errand_package_info') }}</h2></div>
			<!-- <div></div> -->
		</div>
		<!-- <div class="hr-text"></div> -->
		<div class="order-detail">
			<div class="flex-between">
				<div>{{ $t('order_progress.errand_package_type') }}: {{ order.o2o_errand_order_detail }}</div>
				<div></div>
			</div>
			<div class="flex-between">
				<div>
					{{ $t('order_progress.errand_package_value') }}: $
					{{ utils.currencyPrice(order.o2o_errand_order_goods_price) }} {{ $t('general.dollar') }}
				</div>
				<div></div>
			</div>
			<div class="flex-between">
				<div>{{ $t('order_progress.errand_package_weight') }}: {{ order.o2o_errand_order_weight }} {{ $t('general.weight_unit') }}</div>
				<div></div>
			</div>
			<div
				class="flex-between"
				v-if="order.o2o_errand_order_if_pay_on_behalf === '1'"
			>
				<div>
					{{ $t('order_progress.errand_on_behalf_amount') }}: $
					{{ utils.currencyPrice(order.o2o_errand_order_pay_on_behalf_amount) }}
				</div>
				<div></div>
			</div>
		</div>
		<div class="hr-text"></div>
		<div class="flex-between">
			<div>{{ $t('order_progress.errand_tip') }}:</div>
			<div>{{ $t('general.dollar_sign') }} {{ utils.currencyPrice(order.o2o_errand_order_gratuity) }}</div>
		</div>
		<div class="hr-text"></div>
		<div class="flex-between">
			<div>{{ $t('order_progress.total_amount') }}:</div>
			<div>{{ $t('general.dollar_sign') }} {{ utils.currencyPrice(order.o2o_errand_order_amount) }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ErrandSendOrder',
	props: {
		expansion: {
			type: Boolean,
			require: true
		},
		order: {
			type: Object,
			require: true
		}
	}
}
</script>

<style lang='scss'scoped>
.titleBox {
	font-size: $h5;
	border: 1px solid #898989;
    width: 100%;
    text-align: center;
	margin-top: 5px;
}

.flex-between {
	display: flex;
	justify-content: space-between;
}

.flex-center {
	display: flex;
	justify-content: center;
}

.navbar .slider {
	padding: 0.3rem 1rem;
	font-size: $h4;
	margin-top: 2.4rem;
}

.header {
	font-size: $h5;
	border: 1px solid #898989;
	width: 100%;
	text-align: center;
}

.order-description {
	padding: 0rem 0.5rem;
    margin-top: 6px;
}

.address-detail .left,
.center {
	margin: 0rem 0.5rem;
}

.address-detail .right {
	margin-left: 0.5rem;
}

.order-detail {
	padding: 0rem 0.5rem;
	height: 20vh;
	overflow-y: scroll;
}
@media only screen and (min-height: 414px) and (max-height: 736px) {
	.order-detail {
		height: 14vh;
	}
}
@media only screen and (min-height: 812px) and (max-height: 1024px) {
	.order-detail {
		height: 22vh;
	}
}
</style>
